/**
 * DebugBar - Універсальна панель відлагодження з новою структурою
 * Містить 3 основні вкладки: Загальне, Профайлер, Документація
 */

import { MdBugReport } from 'react-icons/md'
import { Button, Drawer, Space } from 'antd'
import React, { useState } from 'react'
import { DebugOverview } from './DebugOverview'
import { DebugProfilerTabs } from './DebugProfilerTabs'

export interface DebugBarProps {
    className?: string
}

export const DebugBar: React.FC<DebugBarProps> = ({ className }) => {
    const [isOpen, setIsOpen] = useState(false)
    const [activeTab, setActiveTab] = useState('profiler')

    return (
        <>
            <Button
                type="primary"
                icon={<MdBugReport style={{ fontSize: '20px' }} />}
                onClick={() => setIsOpen(true)}
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    zIndex: 1000,
                    borderRadius: '50%',
                    width: '50px',
                    height: '50px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                }}
                title="Відкрити панель відлагодження"
            />

            <Drawer
                title="Панель відлагодження"
                styles={{
                    header: { padding: '16px 24px' },
                    body: { padding: '0px 24px' },
                }}
                size="large"
                onClose={() => setIsOpen(false)}
                open={isOpen}
                extra={
                    <Space>
                        <Button
                            type={activeTab === 'overview' ? 'primary' : 'default'}
                            onClick={() => setActiveTab('overview')}
                            size="small"
                        >
                            Загальне
                        </Button>
                        <Button
                            type={activeTab === 'profiler' ? 'primary' : 'default'}
                            onClick={() => setActiveTab('profiler')}
                            size="small"
                        >
                            Профайлер
                        </Button>
                    </Space>
                }
                {...(className && { className })}
            >
                {activeTab === 'overview' && <DebugOverview />}
                {activeTab === 'profiler' && <DebugProfilerTabs />}
            </Drawer>
        </>
    )
}
